export const PASSWORD_RESET_MIN_LENGTH = 6;

const PASSWORD_RESET_VALIDATION_MESSAGE = {
	TOO_SHORT: 'passwordResetTooShort',
	MISMATCH: 'passwordMismatch',
};

export const validatePasswordReset = (password) => {
	if (password.length < PASSWORD_RESET_MIN_LENGTH) {
		return {
			valid: false,
			messageKey: PASSWORD_RESET_VALIDATION_MESSAGE.TOO_SHORT,
		};
	}

	return { valid: true };
};

export const checkPasswordReset = (password, passwordRepeat) => {
	if (password !== passwordRepeat) {
		return {
			valid: false,
			messageKey: PASSWORD_RESET_VALIDATION_MESSAGE.MISMATCH,
		};
	}

	return validatePasswordReset(password);
};
